/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateReviewTemplateBody } from '../models';
// @ts-ignore
import type { DeleteReviewTemplateResponse } from '../models';
// @ts-ignore
import type { GetReviewTemplateResponse } from '../models';
// @ts-ignore
import type { GetUnderReviewParams } from '../models';
// @ts-ignore
import type { GetUnderReviewResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateReviewStatusBody } from '../models';
/**
 * ReviewApiApi - axios parameter creator
 */
export const ReviewApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateReviewTemplateBody} createReviewTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiCreateReviewTemplateApi: async (createReviewTemplateBody: CreateReviewTemplateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReviewTemplateBody' is not null or undefined
            assertParamExists('reviewApiCreateReviewTemplateApi', 'createReviewTemplateBody', createReviewTemplateBody)
            const localVarPath = `/review/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReviewTemplateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reviewTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiDeleteReviewTemplateApi: async (reviewTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reviewTemplateId' is not null or undefined
            assertParamExists('reviewApiDeleteReviewTemplateApi', 'reviewTemplateId', reviewTemplateId)
            const localVarPath = `/review/template/{review_template_id}`
                .replace('{review_template_id}', encodeURIComponent(String(reviewTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetUnderReviewParams} getUnderReviewParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiGetQuestionUnderreviewList: async (getUnderReviewParams: GetUnderReviewParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getUnderReviewParams' is not null or undefined
            assertParamExists('reviewApiGetQuestionUnderreviewList', 'getUnderReviewParams', getUnderReviewParams)
            const localVarPath = `/admin/review/underreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getUnderReviewParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiReviewTemplateApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/review/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateReviewStatusBody} updateReviewStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiUpdateUnderReviewDetails: async (questionId: string, updateReviewStatusBody: UpdateReviewStatusBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('reviewApiUpdateUnderReviewDetails', 'questionId', questionId)
            // verify required parameter 'updateReviewStatusBody' is not null or undefined
            assertParamExists('reviewApiUpdateUnderReviewDetails', 'updateReviewStatusBody', updateReviewStatusBody)
            const localVarPath = `/review/{question_id}/review_status`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReviewStatusBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReviewApiApi - functional programming interface
 */
export const ReviewApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReviewApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateReviewTemplateBody} createReviewTemplateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewApiCreateReviewTemplateApi(createReviewTemplateBody: CreateReviewTemplateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewApiCreateReviewTemplateApi(createReviewTemplateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewApiApi.reviewApiCreateReviewTemplateApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reviewTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewApiDeleteReviewTemplateApi(reviewTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteReviewTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewApiDeleteReviewTemplateApi(reviewTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewApiApi.reviewApiDeleteReviewTemplateApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetUnderReviewParams} getUnderReviewParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewApiGetQuestionUnderreviewList(getUnderReviewParams: GetUnderReviewParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnderReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewApiGetQuestionUnderreviewList(getUnderReviewParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewApiApi.reviewApiGetQuestionUnderreviewList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewApiReviewTemplateApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetReviewTemplateResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewApiReviewTemplateApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewApiApi.reviewApiReviewTemplateApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateReviewStatusBody} updateReviewStatusBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewApiUpdateUnderReviewDetails(questionId: string, updateReviewStatusBody: UpdateReviewStatusBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewApiUpdateUnderReviewDetails(questionId, updateReviewStatusBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReviewApiApi.reviewApiUpdateUnderReviewDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReviewApiApi - factory interface
 */
export const ReviewApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReviewApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ReviewApiApiReviewApiCreateReviewTemplateApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiCreateReviewTemplateApi(requestParameters: ReviewApiApiReviewApiCreateReviewTemplateApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.reviewApiCreateReviewTemplateApi(requestParameters.createReviewTemplateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewApiApiReviewApiDeleteReviewTemplateApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiDeleteReviewTemplateApi(requestParameters: ReviewApiApiReviewApiDeleteReviewTemplateApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteReviewTemplateResponse> {
            return localVarFp.reviewApiDeleteReviewTemplateApi(requestParameters.reviewTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewApiApiReviewApiGetQuestionUnderreviewListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiGetQuestionUnderreviewList(requestParameters: ReviewApiApiReviewApiGetQuestionUnderreviewListRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUnderReviewResponse> {
            return localVarFp.reviewApiGetQuestionUnderreviewList(requestParameters.getUnderReviewParams, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiReviewTemplateApi(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetReviewTemplateResponse>> {
            return localVarFp.reviewApiReviewTemplateApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReviewApiApiReviewApiUpdateUnderReviewDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewApiUpdateUnderReviewDetails(requestParameters: ReviewApiApiReviewApiUpdateUnderReviewDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.reviewApiUpdateUnderReviewDetails(requestParameters.questionId, requestParameters.updateReviewStatusBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reviewApiCreateReviewTemplateApi operation in ReviewApiApi.
 */
export interface ReviewApiApiReviewApiCreateReviewTemplateApiRequest {
    readonly createReviewTemplateBody: CreateReviewTemplateBody
}

/**
 * Request parameters for reviewApiDeleteReviewTemplateApi operation in ReviewApiApi.
 */
export interface ReviewApiApiReviewApiDeleteReviewTemplateApiRequest {
    readonly reviewTemplateId: string
}

/**
 * Request parameters for reviewApiGetQuestionUnderreviewList operation in ReviewApiApi.
 */
export interface ReviewApiApiReviewApiGetQuestionUnderreviewListRequest {
    readonly getUnderReviewParams: GetUnderReviewParams
}

/**
 * Request parameters for reviewApiUpdateUnderReviewDetails operation in ReviewApiApi.
 */
export interface ReviewApiApiReviewApiUpdateUnderReviewDetailsRequest {
    readonly questionId: string

    readonly updateReviewStatusBody: UpdateReviewStatusBody
}

/**
 * ReviewApiApi - object-oriented interface
 */
export class ReviewApiApi extends BaseAPI {
    /**
     * 
     * @param {ReviewApiApiReviewApiCreateReviewTemplateApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewApiCreateReviewTemplateApi(requestParameters: ReviewApiApiReviewApiCreateReviewTemplateApiRequest, options?: RawAxiosRequestConfig) {
        return ReviewApiApiFp(this.configuration).reviewApiCreateReviewTemplateApi(requestParameters.createReviewTemplateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewApiApiReviewApiDeleteReviewTemplateApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewApiDeleteReviewTemplateApi(requestParameters: ReviewApiApiReviewApiDeleteReviewTemplateApiRequest, options?: RawAxiosRequestConfig) {
        return ReviewApiApiFp(this.configuration).reviewApiDeleteReviewTemplateApi(requestParameters.reviewTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewApiApiReviewApiGetQuestionUnderreviewListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewApiGetQuestionUnderreviewList(requestParameters: ReviewApiApiReviewApiGetQuestionUnderreviewListRequest, options?: RawAxiosRequestConfig) {
        return ReviewApiApiFp(this.configuration).reviewApiGetQuestionUnderreviewList(requestParameters.getUnderReviewParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewApiReviewTemplateApi(options?: RawAxiosRequestConfig) {
        return ReviewApiApiFp(this.configuration).reviewApiReviewTemplateApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReviewApiApiReviewApiUpdateUnderReviewDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reviewApiUpdateUnderReviewDetails(requestParameters: ReviewApiApiReviewApiUpdateUnderReviewDetailsRequest, options?: RawAxiosRequestConfig) {
        return ReviewApiApiFp(this.configuration).reviewApiUpdateUnderReviewDetails(requestParameters.questionId, requestParameters.updateReviewStatusBody, options).then((request) => request(this.axios, this.basePath));
    }
}

